import { useEffect, useState } from 'react'
import type { ShellMode } from './types'

const Q_PHONE = '(max-width: 639.98px)'
const Q_WIDE = '(min-width: 1024px)'
const Q_COARSE = '(pointer: coarse)'

function read(): { mode: ShellMode; wide: boolean } {
  if (typeof window === 'undefined' || !window.matchMedia) return { mode: 'desktop', wide: true }
  const phone = window.matchMedia(Q_PHONE).matches
  const wide = window.matchMedia(Q_WIDE).matches
  const coarse = window.matchMedia(Q_COARSE).matches
  const mode: ShellMode = phone ? 'phone' : wide && !coarse ? 'desktop' : 'tablet'
  return { mode, wide }
}

/**
 * Handy (< 640 px): Dock unten. Tablet (640–1023 px oder Touch): Rail + Drawer.
 * Desktop (>= 1024 px, Maus): Rail + Drawer + Befehlspalette (Such-Button).
 * `wide` = Breite >= 1024 px (Anheften des Drawers möglich).
 */
export function useShellMode() {
  const [state, setState] = useState(read)
  useEffect(() => {
    const mqs = [Q_PHONE, Q_WIDE, Q_COARSE].map(q => window.matchMedia(q))
    const on = () => setState(prev => {
      const n = read()
      return n.mode === prev.mode && n.wide === prev.wide ? prev : n
    })
    mqs.forEach(m => m.addEventListener('change', on))
    return () => mqs.forEach(m => m.removeEventListener('change', on))
  }, [])
  return state
}
